import { render } from "./UserListPage.vue?vue&type=template&id=3020b424"
import script from "./UserListPage.vue?vue&type=script&lang=js"
export * from "./UserListPage.vue?vue&type=script&lang=js"
script.render = render

export default script